const tournoiDataSet = [
    {
        id: "1",
        title: "Tournoi 1",
        price: 75.00
    },
    {
        id: "2",
        title: "Tournoi 2",
        price: 100.00
    },
    {
        id: "3",
        title: "Tournoi 3",
        price: 125.00
    }
]

function getTournoiData(id) {
    let tournoiData = tournoiDataSet.find(tournoi => tournoi.id === id);

    if (tournoiData === undefined) {
        console.log("Tournoi data does not exist for ID: " + id);
        return undefined;
    }

    return tournoiData;
}

export { tournoiDataSet, getTournoiData };